import styled, { css } from 'styled-components';

export const CartTileWrapper = styled.div<{ $disabled: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: 64px auto;
  grid-template-rows: auto auto;
  grid-template-areas:
    'media info'
    'media-placeholder price';
  gap: 16px;
  padding: 12px 20px;
  background: var(--v3-black-0);
  border-radius: 12px;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
    `}
`;

export const NftMedia = styled.img<{ $mediaLoaded: boolean }>`
  grid-area: media-placeholder;
  width: 64px;
  height: 0;
  border-radius: 16px;

  ${({ $mediaLoaded }) =>
    $mediaLoaded &&
    css`
      grid-area: media;
      height: 64px;
    `}
`;

export const CartTileInfo = styled.div`
  grid-area: info;
  display: grid;
  grid-template-columns: 1fr min-content;
  grid-template-rows: auto auto;
  gap: 4px;
`;

export const CartTileTitle = styled.div`
  grid-column: 1 / 3;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  word-break: break-word;
  color: var(--v3-text-color);
`;

export const CartTilePriceWrapper = styled.div`
  grid-area: price;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border-top: 1px solid var(--v3-black-2);
  padding: 8px 0 4px;
`;

export const CartTilePriceLabel = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: var(--v3-text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CartTilePrice = styled.div`
  color: var(--v3-text-color);
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
`;
